import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
// The same component is used for both versions
import ModalChangePassword from '../../../components/layout/modals/ModalChangePassword'
import authActions from '../../../actions/auth'
import { getFormSyncErrors, getFormValues } from 'redux-form'

export function mapStateToProps (state) {
  return {
    emailAddress: state.auth.emailAddress,
    passwordPolicy: state.auth.passwordPolicy,
    showChangePasswordModal: state.auth.passwordExpired,
    tokenId: state.auth.tokenId,
    formValues: getFormValues('modalChangePassword')(state),
    formErrors: getFormSyncErrors('modalChangePassword')(state)
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      ...authActions
    }, dispatch)
  }
}

const decoratedComponent = ModalChangePassword

export default connect(mapStateToProps, mapDispatchToProps)(translate()(decoratedComponent))
